/**
 *  Util methods for generic HTML or SVG DOM elements.
 */

/**
 * Helper to parse a single attribute value safely.
 *
 * @param el
 * @param attr
 * @returns number
 */
export function getParsedAttr(el: Element, attr: string): number {
    return parseFloat(el.getAttribute(attr) ?? '') || 0;
}
